module.exports = __webpack_public_path__ + "static/media/Portrait-10227.988abcb0.jpg";